module.exports = __webpack_public_path__ + "static/img/receive.777e0488.png";